import { render } from "./IconLinkChain.vue?vue&type=template&id=1d5da148"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLinkChain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d5da148"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d5da148', __exports__)) {
    api.reload('1d5da148', __exports__)
  }
  
  module.hot.accept("./IconLinkChain.vue?vue&type=template&id=1d5da148", () => {
    api.rerender('1d5da148', render)
  })

}


export default __exports__